export default function styles() {
  return {
    details: {
      marginTop: '1.3rem',
    },
  }
}
